import Base from "../../../base";
import ActivityService from "../../../../services/running/activity";
import Form from "../../../layout/form";

export default class ActivityAdd extends Base
{
    boot() {
        this.state = {
            model:{
                name:'',
                content:'',
                image:'',
                sort:0,
                status:1
            }
        }
    }

    service() {
        return ActivityService;
    }

    render() {
        return (
            <Form
                model={this.state.model}
                fields={{
                    name: '名称',
                    image:{name:'封面', type:'image'},
                    content:{name:'内容', type:'editor', height:'400px'},
                    sort:{name:'排序', type:'number'},
                    status:{name:'状态', type: 'radio', data: this.server.status}
                }}
            />
        );
    }
}
